const API = process.env.REACT_APP_BACKEND_URL;

export const initAttribution = () => {
  try {
    if (!sessionStorage.getItem('ea33_entry_page')) {
      sessionStorage.setItem('ea33_entry_page', window.location.pathname);
    }
  } catch {}
};

export const getAttribution = () => {
  let entry = '';
  try { entry = sessionStorage.getItem('ea33_entry_page') || window.location.pathname; } catch {}
  return { entry_page: entry, source_page: window.location.pathname };
};

export const track = (event, props = {}) => {
  try { window.posthog?.capture?.(event, props); } catch {}
  try {
    const payload = JSON.stringify({ event, props: { ...getAttribution(), ...props } });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/api/events`, new Blob([payload], { type: 'application/json' }));
    } else {
      fetch(`${API}/api/events`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: payload, keepalive: true });
    }
  } catch {}
};
